import React, { Component } from 'react';
import { Loader, Dimmer } from 'semantic-ui-react';
import AutoPsiForm from '../views/AutoPsi/Form';
import ReviewForm from '../views/AutoPsi/ReviewForm';
import Enrollment from '../views/AutoPsi/Enrollment';

class AutoPsi extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dealerNumber: '',
      requestType: null,
      dealername: '',
      contactname: '',
      contactemail: '',
      contactphone: '',
      product: null,
      cascade: null,
      flatrate: null,
      purchaseChannel: null,
      location: null,
      miles: null,
      startDate: null,
      openReviewModal: false,
      modify: false,
      cancel: false,
    };
  }

  componentDidMount() {}

  onCheckboxHandler = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  onSelectHandler = (field, value) => {
    this.setState({
      [field]: value,
    });
  };

  onNewFormSubmitHandler = values => {
    this.setState({
      ...values,
    });
  };

  onCloseHandler = () => {
    this.setState({ openReviewModal: false });
  };

  modifyCloseHandler = () => {
    this.setState({ modify: false });
  };

  redirectToAutoPsiTab = () => {
    this.setState({ openReviewModal: false });
  };

  render() {
    const {
      loading,
      openReviewModal,
      modify,
      dealerNumber,
      requestType,
      dealername,
      contactname,
      contactemail,
      contactphone,
      product,
      cascade,
      flatrate,
      purchaseChannel,
      location,
      miles,
      startDate,
      cancel,
    } = this.state;

    return (
      <div className='auto-psi'>
        {' '}
        {loading && (
          <Dimmer active inverted>
            <Loader size='large'> Loading </Loader>{' '}
          </Dimmer>
        )}{' '}
        {!modify && (
          <AutoPsiForm
            onSelectHandler={this.onSelectHandler}
            onCheckboxHandler={this.onCheckboxHandler}
            onSubmitHandler={this.onNewFormSubmitHandler}
            loading={loading}
            dealerNumber={dealerNumber}
            requestType={requestType}
            dealername={dealername}
            contactname={contactname}
            contactemail={contactemail}
            contactphone={contactphone}
            product={product}
            cascade={cascade}
            flatrate={flatrate}
            purchaseChannel={purchaseChannel}
            location={location}
            miles={miles}
            startDate={startDate}
            openReviewModal={openReviewModal}
            modify={modify}
            cancel={cancel}
          />
        )}{' '}
        {openReviewModal && (
          <ReviewForm
            onCloseHandler={this.onCloseHandler}
            loading={loading}
            dealerNumber={dealerNumber}
            requestType={requestType}
            dealername={dealername}
            contactname={contactname}
            contactemail={contactemail}
            contactphone={contactphone}
            product={product}
            cascade={cascade}
            flatrate={flatrate}
            purchaseChannel={purchaseChannel}
            location={location}
            miles={miles}
            startDate={startDate}
            openReviewModal={openReviewModal}
            modify={modify}
            cancel={cancel}
            redirectToAutoPsiTab={this.redirectToAutoPsiTab}
            modifyCloseHandler={this.modifyCloseHandler}
          />
        )}{' '}
        {modify && (
          <Enrollment
            onSubmitHandler={this.onNewFormSubmitHandler}
            modifyCloseHandler={this.modifyCloseHandler}
            loading={loading}
            dealerNumber={dealerNumber}
            requestType={requestType}
            dealername={dealername}
            contactname={contactname}
            contactemail={contactemail}
            contactphone={contactphone}
            product={product}
            cascade={cascade}
            flatrate={flatrate}
            purchaseChannel={purchaseChannel}
            location={location}
            miles={miles}
            startDate={startDate}
            openReviewModal={openReviewModal}
            modify={modify}
            cancel={cancel}
          />
        )}{' '}
      </div>
    );
  }
}

export default AutoPsi;
